import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../api/api";
import Modal from "./Modal";
import { toast } from "react-toastify";
import { useAuth } from "./Auth/userContext";

const Header = ({ setAdmin, admin }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const signoutref = useRef();
  const [showModal, setShowModal] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    const handleClose = (event) => {
      if (
        signoutref.current &&
        !signoutref.current.contains(event.target) &&
        !event.target.closest(".signoutclosest")
      ) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClose);

    return () => {
      document.removeEventListener("mousedown", handleClose);
    };
  }, []);

  const handleSignOut = async () => {
    setShowModal(false);
    const response = await logout();
    if (response.data) {
      localStorage.removeItem("token");
      navigate("/signin");
    } else {
      // alert(response.error.message);
      toast.error(response.error.message);
    }
  };

  const checkAdmin = () => {
    if (user?.super_user === "1" && !admin) {
      setAdmin(true);
      navigate("/digitalconversion/add_user");
      setMenuOpen(false);
    }
  };

  return (
    <div className="w-full  flex h-24 justify-center items-center gap-8 border-[1px] border-b-commonborder">
      <div className="w-[20%] flex justify-center">
        <img
          src={process.env.PUBLIC_URL + "/images/transforma.png"}
          alt="transforma_logo"
        />
      </div>
      <div className="w-[60%] text-left text-24 font-semibold">
        Digital Conversion
      </div>
      <div className="w-[20%] relative border-l-[1px] border-commonborder h-full flex justify-between items-center p-5 relative">
        <div className="flex flex-col text-left gap-1 w-9/12 signoutclosest">
          <div
            onClick={() => setMenuOpen(!menuOpen)}
            className="flex w-full items-center cursor-pointer"
          >
            <p className="text-16 font-semibold w-full capitalize">
              {user?.email || "Admin"}
            </p>
            <div
              className={`w-auto transform transition-transform duration-300 ${
                menuOpen ? "rotate-[180deg]" : "rotate-[0deg]"
              }`}
            >
              <img
                src={process.env.PUBLIC_URL + "/images/downarrow.svg"}
                alt="open-menu"
              />
            </div>
          </div>
          {/* <p className="text-14 text-subtitle">{user?.user_name ||"Admin"}</p> */}
        </div>
        {menuOpen && (
          <div
            ref={signoutref}
            className="absolute left-0 top-[105%] border-[1px] border-commonborder w-[80%] py-6 bg-white rounded-[16px] flex flex-col gap-3 items-center"
          >
            {user?.super_user === "1" && (
              <button
                onClick={() => {
                  checkAdmin();
                }}
                className="px-6 py-1 w-8/12 bg-highlight text-white rounded-[12px]"
              >
                Admin Panel
              </button>
            )}

            <button
              onClick={() => {
                setShowModal(true);
              }}
              className="px-6 py-1 w-8/12 bg-highlight text-white rounded-[12px]"
            >
              SignOut
            </button>
          </div>
        )}
      </div>
      {showModal && (
        <div className="flex items-center">
          <Modal
            title={"Alert"}
            body={"Do you wish to signout ?"}
            setShow={setShowModal}
            setConfirm={handleSignOut}
            confirmbtn={"Confirm"}
            cancelbtn={"Cancel"}
          />
        </div>
      )}
    </div>
  );
};

export default Header;
